<template>
	<div class="add-user">
		<MainNav />
		<div class="container">
			<form class="pt-5" novalidate @submit="checkForm">
				<div class="row">
					<div class="form-group col-md-2">
						<select class="form-control" id="Title" name="Title" v-model="signUp.Title">
							<option value="error">Title *</option>
							<option v-for="title in titles" v-bind:key="title.Id" v-bind:value="title.Id">
								{{title.Title}}
							</option>
						</select>
					</div>
					<div class="form-group col-md-5">
						<input type="text" class="form-control" id="FirstName" placeholder="First name *" required v-model="signUp.FirstName">
					</div>
					<div class="form-group col-md-5">
						<input type="text" class="form-control" id="LastName" placeholder="Last name *" required v-model="signUp.LastName">
					</div>
				</div>
				<div class="row">
					<div class="form-group col-md-6">
						<input type="tel" class="form-control" id="TelephoneNumber" placeholder="Telephone" v-model="signUp.TelephoneNumber">
					</div>
					<div class="form-group col-md-6">
						<input type="tel" class="form-control" id="MobileNumber" placeholder="Mobile" v-model="signUp.MobileNumber">
					</div>
				</div>
				<div class="row">
					<div class="form-group col-md-6">
						<input type="email" class="form-control" id="Email" name="Email" placeholder="Email *" required v-model="signUp.Email">
					</div>
					<div class="form-group col-md-6">
						<input type="email" class="form-control" id="ConfirmEmail" name="ConfirmEmail" placeholder="Confirm email *" required v-model="signUp.ConfirmEmail">
					</div>
				</div>
				<div class="row">
					<div class="form-group col-md-6">
						<input type="text" class="form-control" id="Organisation" placeholder="Organisation *" required v-model="signUp.Organisation">
					</div>
					<div class="form-group col-md-6">
						<input type="text" class="form-control" id="Position" placeholder="Position *" required v-model="signUp.Position">
					</div>
				</div>
				<div class="row">
					<div class="form-group col-md-6">
						<input type="text" class="form-control" id="BuildingNameOrNumber" placeholder="Building name/number" v-model="signUp.BuildingNameOrNumber">
					</div>
					<div class="form-group col-md-6">
						<input type="text" class="form-control" id="Street" placeholder="Street" v-model="signUp.Street">
					</div>
				</div>
				<div class="row">
					<div class="form-group col-md-6">
						<input type="text" class="form-control" id="City" placeholder="City" v-model="signUp.City">
					</div>
					<div class="form-group col-md-6">
						<input type="text" class="form-control" id="PostCode" placeholder="Postcode" v-model="signUp.PostCode">
					</div>
				</div>
				<div class="row">
					<div class="form-group col-md-6">
						<input type="password" class="form-control" id="Password" placeholder="Password *" required v-model="signUp.Password">
					</div>
					<div class="form-group col-md-6">
						<input type="password" class="form-control" id="ConfirmPassword" placeholder="Confirm Password *" required v-model="signUp.ConfirmPassword">
					</div>
				</div>
				<div class="form-group">
					<textarea class="form-control" id="ReportReason" v-model="signUp.ReportReason" rows="3" placeholder="Reason for purchasing a report *" required></textarea>
				</div>

				<div v-if="signUpErrors.length">
					<div class="alert alert-danger alert-dismissible fade show" role="alert" v-for="error in signUpErrors">
						{{error}}
						<button type="button" class="close" data-dismiss="alert" aria-label="Close">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
				</div>
				<div v-if="createUserErrors.length">
					<div class="alert alert-danger alert-dismissible fade show" role="alert" v-for="error in createUserErrors">
						{{error}}
						<button type="button" class="close" data-dismiss="alert" aria-label="Close">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
				</div>
				<div v-if="createUserSuccess" class="alert alert-success alert-dismissible fade show" role="alert">
					User created successfully!
					<button type="button" class="close" data-dismiss="alert" aria-label="Close">
						<span aria-hidden="true">&times;</span>
					</button>
				</div>

				<button v-if="loading" class="btn btn-primay btn-block mb-3" disabled>Loading...</button>
				<button v-else type="submit" class="btn btn-primary btn-block mb-3">Add User</button>
			</form>
		</div>
		<Footer />
	</div>
</template>
<script>
import MainNav from "@/components/MainNav.vue";
import Footer from "@/components/Footer.vue";

export default {
  name: 'app',
  components: {
    MainNav,
    Footer
	},
	data() {
    return {
      titles: [
        {
            Title: "Mr",
            Id: 0
        },
        {
            Title: "Mrs",
            Id: 1
        },
        {
            Title: "Miss",
            Id: 2
        },
        {
            Title: "Dr",
            Id: 3
        },
        {
            Title: "Ms",
            Id: 4
        },
        {
            Title: "Prof",
            Id: 5
        },
        {
            Title: "Rev",
            Id: 6
        },
        {
            Title: "Lady",
            Id: 7
        },
        {
            Title: "Sir",
            Id: 8
        },
        {
            Title: "Capt",
            Id: 9
        }
      ],
      // signUp: {
      //   Email: "ben@hiyield.co.uk",
      //   ConfirmEmail: "ben@hiyield.co.uk",
      //   FirstName: "Ben",
      //   LastName: "Short",
      //   TelephoneNumber: "01234567890",
      //   MobileNumber: "0987654321",
      //   Organisation: "HiYield Ltd",
      //   BuildingNameOrNumber: "123",
      //   Street: "Test Street",
      //   City: "Test City",
      //   PostCode: "AA111AA",
      //   Position: "Developer",
      //   ReportReason: "Reason for report yo",
      //   Password: "Password123!",
      //   ConfirmPassword: "Password123!",
      //   Title: "0"
      // },
      signUp: {
        Title: "error"
      },
      signUpErrors: [],
      signUpSuccess: false
    };
	},
	computed: {
    loading () {
      return this.$store.state.loading;
		},
		createUserSuccess() {
			return this.$store.getters.createUserSuccess;
		},
		createUserErrors() {
			return this.$store.getters.createUserErrors;
		}
	},
	methods: {
    checkForm(e){
      e.preventDefault();
      this.signUpErrors = [];

      //check required
      let missingInputs = 0;
      for(let formInput of e.target.elements) {
        const value = formInput.value.trim();

        if (formInput.nodeName === "INPUT" || formInput.nodeName === "TEXTAREA") {
          if(formInput.hasAttribute('required')){
            if(value){
              formInput.classList.remove("is-invalid");
              formInput.classList.add("is-valid");
            } else {
              formInput.classList.remove("is-valid");
              formInput.classList.add("is-invalid");
              missingInputs++;
            }
          }
        }

        if (formInput.nodeName === "SELECT"){
          if(value === "error"){
            formInput.classList.remove("is-valid");
            formInput.classList.add("is-invalid");
            missingInputs++;
          } else {
            formInput.classList.remove("is-invalid");
            formInput.classList.add("is-valid");
          }
        }
      }

      if(missingInputs > 0){
        this.signUpErrors.push("You are missing some required fields, please try again");
      } else {
        //Email checks
        if(this.signUp.Email !== this.signUp.ConfirmEmail){
          let emailInput = document.getElementById("Email");
          let confirmEmailInput = document.getElementById("ConfirmEmail");

          this.signUpErrors.push("Email addresses don't match!");

          emailInput.classList.remove("is-valid");
          emailInput.classList.add("is-invalid");

          confirmEmailInput.classList.remove("is-valid");
          confirmEmailInput.classList.add("is-invalid");
        }

        //Password checks
        if(this.signUp.Password !== this.signUp.ConfirmPassword){

          let passwordInput = document.getElementById("Password");
          let confirmPasswordInput = document.getElementById("ConfirmPassword");

          this.signUpErrors.push("Passwords don't match!");

          passwordInput.classList.remove("is-valid");
          passwordInput.classList.add("is-invalid");

          confirmPasswordInput.classList.remove("is-valid");
          confirmPasswordInput.classList.add("is-invalid");
        }
      }

			if(this.signUpErrors.length === 0){
				this.submit();
			}
		},
		async submit(){
			this.$store.dispatch('addUser', this.signUp);
		}
	}
};
</script>